import { combineReducers } from "redux";

const rootReducer = combineReducers({});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
